export const redact = (regex: RegExp, text: string): string => text.replace(regex, 'redacted');
